export default __webpack_public_path__ + "static/banner-f8aa0d6d9c49c1e3183bcf5a45a9495c.png";